module.exports = __webpack_public_path__ + "img/instagram.32e508b.svg";